import { keycloak } from "../../..";
import { useAppSelector } from "../../../app/store";
import Loader from "../../../components/ui/Loader";
import { useGetSingleCompanyQuery } from "../../../features/portal/companyOnboard/companyOnboardApi";
import { useGetProjectsByUserQuery } from "../../../features/portal/Products/productsApi";
import useError from "../../../hooks/useError";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { createHash } from "../../../utils/hash";
import {
  buildProductLaunchUrl,
  resolveLocalDigigoRedirectUri,
} from "../../../utils/redirectUri";

type KeywordType = {
  projectId: number;
  dynamicId: number;
  dynamicKeyword: string;
};

export default function ProductClient() {
  const { user } = useAppSelector((state) => state.auth);
  const { isError, error, isLoading, data } = useGetProjectsByUserQuery({
    params: {
      userid: user?.data?.id,
    },
  });
  const {
    isError: isCompanyError,
    error: companyError,
    isLoading: isCompanyLoading,
    data: companyData,
  } = useGetSingleCompanyQuery(user?.data?.company_id || "", {
    skip: !user?.data?.company_id,
  });
  useError(isError, error, "User get fail");
  useError(isCompanyError, companyError, "Company get fail");

  // console.log(companyData?.data?.dynamicId, companyData?.data?.dyncamicKeyword);

  const handleProject = (
    role: string,
    redirectUri: string,
    { projectId }: KeywordType
  ) => {
    const finalRedirectUri = resolveLocalDigigoRedirectUri(redirectUri);
    localStorage.setItem("project_role", role);
    localStorage.setItem("product_id", String(projectId));
    const dynamicId = companyData?.data?.dynamicId;
    const dynamicKeyword = companyData?.data?.dyncamicKeyword;

    // if (!dynamicId || !dynamicKeyword) {
    //   toast("error", "Please set dynamic id and dynamic keyword");
    //   return;
    // }

    // console.log("projectId Check", projectId);

    const pId = projectId ? createHash(projectId) : "";
    const dId = dynamicId ? createHash(dynamicId) : "";
    const dText = dynamicKeyword ? createHash(dynamicKeyword) : "";

    const url = buildProductLaunchUrl(finalRedirectUri, {
      projectType: pId,
      dynamicId: dId,
      dynamicKeyword: dText,
      token: keycloak?.token,
    });

    const bsrm_url = "/admin/bsrm/dashboard";

    if (finalRedirectUri?.includes(bsrm_url)) {
      localStorage.setItem("BSRM_USER", "BSRM_USER");
    }

    if (finalRedirectUri) window.location.assign(url);
    // navigate("/admin/salary-disbursement/batch");
  };

  const handleRedirect = (
    // role: string,
    redirectUri: string,
    { projectId, dynamicId, dynamicKeyword }: KeywordType
  ) => {
    const finalRedirectUri = resolveLocalDigigoRedirectUri(redirectUri);
    // localStorage.setItem("project_role", role);
    if (finalRedirectUri) {
      const pId = projectId ? createHash(projectId) : "";
      const dId = dynamicId ? createHash(dynamicId) : "";
      const dText = dynamicKeyword ? createHash(dynamicKeyword) : "";

      const url = buildProductLaunchUrl(finalRedirectUri, {
        projectType: pId,
        dynamicId: dId,
        dynamicKeyword: dText,
        token: keycloak?.token,
      });

      console.log(url);

      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  // console.log("data", data?.data);

  return (
    <>
      <SidebarLayout title="Products">
        {isLoading || isCompanyLoading ? (
          <Loader />
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {data?.data?.map((val, index) => {
              const redirectUri = val?.project?.redirectUri?.trim();

              return (
                // <div
                //   key={index}
                //   onClick={() => {
                //     val?.project?.redirectToAnotherWebsite
                //       ? handleRedirect(redirectUri, {
                //           projectId: val?.project?.id,
                //           dynamicId: val?.project?.dynamicId,
                //           dynamicKeyword: val?.project?.dyncamicKeyword,
                //         })
                //       : handleProject(val?.role?.roleName, redirectUri, {
                //           projectId: val?.project?.id,
                //           dynamicId: val?.project?.dynamicId,
                //           dynamicKeyword: val?.project?.dyncamicKeyword,
                //         });
                //   }}
                //   className={` relative cursor-pointer rounded-lg shadow hover:shadow-md transition-shadow ${
                //     !redirectUri ? "pointer-events-none opacity-50" : ""
                //   }`}
                // >
                //   <img
                //     className="h-[120px] w-[120px] object-cover rounded-lg"
                //     src={val?.project?.logo}
                //     alt="project_logo"
                //   />
                //   <div className="p-2 border-t border-gray">
                //     <h2 className="text-center text-base font-semibold">
                //       {val?.project?.name}
                //     </h2>

                //     {/* <Button
                //     className="absolute right-4 bottom-4 z-10 overflow-hidden"
                //     icon={<LinkIcon />}
                //     onClick={(e) => {
                //       e.stopPropagation();
                //       handleRedirect(redirectUri, {
                //         projectId: val?.project?.id,
                //         dynamicId: val?.project?.dynamicId,
                //         dynamicKeyword: val?.project?.dyncamicKeyword,
                //       });
                //     }}
                //     size="small"
                //   /> */}
                //   </div>
                // </div>

                <>
                  <div
                    key={index}
                    onClick={() => {
                      val?.project?.redirectToAnotherWebsite
                        ? handleRedirect(redirectUri, {
                            projectId: val?.project?.id,
                            dynamicId: val?.project?.dynamicId,
                            dynamicKeyword: val?.project?.dyncamicKeyword,
                          })
                        : handleProject(val?.role?.roleName, redirectUri, {
                            projectId: val?.project?.id,
                            dynamicId: val?.project?.dynamicId,
                            dynamicKeyword: val?.project?.dyncamicKeyword,
                          });
                    }}
                    className={`flex flex-col items-center justify-center w-[120px] gap-2 cursor-pointer ${
                      !redirectUri ? "pointer-events-none opacity-50" : ""
                    }`}
                  >
                    <div className="bg-white p-2 rounded-lg drop-shadow-[0_4px_4px_rgba(0,0,0,0.1)]">
                      <img
                        className="h-[64px] w-[64px] object-contain"
                        src={val?.project?.logo}
                        alt="project_logo"
                      />
                    </div>
                    <h2 className="text-sm text-center font-medium text-gray-800 h-[40px] line-clamp-2">
                      {val?.project?.name}
                    </h2>
                  </div>
                </>
              );
            })}
          </div>
        )}
      </SidebarLayout>
    </>
  );
}
